import { dayjs } from '@shared/libs'
import { useEffect, useState } from 'react'

import { BadgeV1, ClockIcon } from '@podo-app/design-system-temp'

const DdayBadge = ({ endDate }: { endDate: string }) => {
  const now = dayjs().startOf('day')
  const targetDate = dayjs(endDate).startOf('day')
  const diff = targetDate.diff(now, 'day')

  const dDayText = diff === 0 ? 'D-day' : diff > 0 ? `D-${diff}` : `D+${Math.abs(diff)}`

  return (
    <BadgeV1 className="bg-red-light px-2 text-red-normal flex gap-[5px]">
      <ClockIcon size={16} viewBox="0 0 16 16" />
      {dDayText}
    </BadgeV1>
  )
}

const CountDownTimeBadge = ({ endDate }: { endDate: string }) => {
  const [remainingTime, setRemainingTime] = useState(() => {
    const end = dayjs(endDate)
    const now = dayjs()
    const diff = end.diff(now, 'second')
    return diff > 0 ? diff : 0
  })

  useEffect(() => {
    if (remainingTime <= 0) {
      return
    }

    const interval = setInterval(() => {
      setRemainingTime((prev) => (prev > 0 ? prev - 1 : 0))
    }, 1000)

    return () => clearInterval(interval)
  }, [remainingTime])

  return (
    <BadgeV1 className="bg-red-light px-2 text-red-normal flex gap-[5px]">
      <ClockIcon size={16} viewBox="0 0 16 16" />
      {dayjs.duration(remainingTime, 'seconds').format('HH:mm:ss')}
    </BadgeV1>
  )
}

export { CountDownTimeBadge, DdayBadge }
